import { render, staticRenderFns } from "./user2.vue?vue&type=template&id=1888fe17&scoped=true&"
import script from "./user2.vue?vue&type=script&lang=js&"
export * from "./user2.vue?vue&type=script&lang=js&"
import style0 from "./user2.vue?vue&type=style&index=0&id=1888fe17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888fe17",
  null
  
)

export default component.exports